module.exports = __webpack_public_path__ + "img/RestricatedBackgroundImage.34690ea5.svg";